import "../0.styles.css";
import { MaterialReactTable } from "material-react-table";
import { Box, Button, Container, Grid, IconButton, TextField, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Switch } from "@mui/material";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { deleteTableDots, functions, instance, validateFunction } from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { useMemo, useState } from "react";
import { LoaderBox } from "../Components/LoaderBox";
import { InstruccionesModal } from "../Components/InstruccionesModal";

function CategoriasBeneficiario() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [openForm, setOpenForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [grupo, setGrupo] = useState("");
  const [nombre, setNombre] = useState("");
  const [orden, setOrden] = useState(0);
  const [activo, setActivo] = useState(true);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({ title: "", text: "" });

  deleteTableDots(1);

  const columns = useMemo(() => [
    { accessorKey: "Id", header: "ID" },
    { accessorKey: "Grupo", header: "Grupo" },
    { accessorKey: "Nombre", header: "Nombre" },
    { accessorKey: "Orden", header: "Orden" },
    { accessorFn: (row) => row.Activo ? "Sí" : "No", id: "activo", header: "Activo" },
    {
      accessorFn: () => "edit",
      id: "edit",
      header: "",
      size: 50,
      enableColumnFilter: false,
      Cell: ({ row }) => validateFunction(user, functions.ManageCategoriaBeneficiario) && (
        <Button onClick={() => handleEditar(row.original)}>
          <EditTwoToneIcon /> Editar
        </Button>
      ),
    },
  ], []);

  function populateTable() {
    instance.get("/categoriaBeneficiario/listCompleto")
      .then((res) => setItems(res.data))
      .catch((err) => {
        setDialog({
          title: "ERROR",
          text: err.response?.status === 500
            ? "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde."
            : err.response?.data?.message || "Error desconocido"
        });
        setOpenDialog(true);
      });
  }

  if (isLoading) {
    populateTable();
    setLoading(false);
  }

  const handleEditar = (row) => {
    setEditId(row.Id);
    setGrupo(row.Grupo);
    setNombre(row.Nombre);
    setOrden(row.Orden);
    setActivo(!!row.Activo);
    setOpenForm(true);
  };

  const handleGuardar = () => {
    if (!grupo || !nombre) {
      setDialog({ title: "Aviso", text: "Debe ingresar el grupo y el nombre." });
      setOpenDialog(true);
      return;
    }
    const payload = { grupo, nombre, orden: Number(orden) || 0 };

    const request = editId
      ? instance.put("/categoriaBeneficiario/actualizar", { id: editId, activo, ...payload })
      : instance.post("/categoriaBeneficiario/crear", payload);

    request
      .then(() => {
        setDialog({ title: "Aviso", text: editId ? "Categoría actualizada exitosamente." : "Categoría creada exitosamente." });
        setOpenDialog(true);
        limpiarForm();
        setOpenForm(false);
        populateTable();
      })
      .catch((err) => {
        setDialog({
          title: "ERROR",
          text: err.response?.status === 500
            ? "Existe algún problema con el servidor."
            : err.response?.data?.message || "Error desconocido"
        });
        setOpenDialog(true);
      });
  };

  const limpiarForm = () => {
    setEditId(null);
    setGrupo("");
    setNombre("");
    setOrden(0);
    setActivo(true);
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container maxWidth="xl" sx={{ marginTop: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2, flexWrap: 'wrap' }}>
          <h2 style={{ margin: 0 }}>Categorías de beneficiarios</h2>
          <InstruccionesModal clave="CategoriasBeneficiario" />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 4 }}>
          <Grid container gap={{ xs: "0px", sm: "12px" }}>
            <Grid item xs={12}>
              <MaterialReactTable
                localization={MRT_Localization_ES}
                columns={columns}
                data={items}
                enableColumnFilterModes={false}
                enableColumnOrdering={false}
                enableGrouping={false}
                enablePinning={false}
                enableRowActions={false}
                initialState={{
                  pagination: { pageSize: 10 },
                  showColumnFilters: false,
                  columnVisibility: { Id: false, edit: validateFunction(user, functions.ManageCategoriaBeneficiario) },
                  sorting: [{ id: "Grupo", desc: false }],
                }}
                positionToolbarAlertBanner="none"
                enableColumnFilters={false}
                enableGlobalFilter={true}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableHiding={false}
                enablePagination={true}
                enableTopToolbar={true}
                enableBottomToolbar={true}
                renderTopToolbarCustomActions={() => (
                  validateFunction(user, functions.ManageCategoriaBeneficiario) && (
                  <IconButton color="success" onClick={() => setOpenForm(true)} variant="contained">
                    <AddCircleTwoToneIcon />
                    <p className="IconButtonText">Agregar</p>
                  </IconButton>
                  )
                )}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editId ? "Editar categoría de beneficiario" : "Nueva categoría de beneficiario"}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                required fullWidth label="Grupo" value={grupo}
                onChange={(e) => setGrupo(e.target.value)}
                helperText="Ej. Sexo, Edad, Etnia, Pertenencia, Discapacidad, Canal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth type="number" label="Orden" value={orden}
                onChange={(e) => setOrden(e.target.value)}
                helperText="Orden de aparición dentro del grupo"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField required fullWidth label="Nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} />
            </Grid>
            {editId && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Switch checked={activo} onChange={(e) => setActivo(e.target.checked)} />}
                  label="Activo"
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { limpiarForm(); setOpenForm(false); }}>Cancelar</Button>
          <Button variant="contained" onClick={handleGuardar}>{editId ? "Actualizar" : "Crear"}</Button>
        </DialogActions>
      </Dialog>

      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
      />
    </LoaderBox>
  );
}

export { CategoriasBeneficiario };
